import { render, staticRenderFns } from "./Assinaturas.vue?vue&type=template&id=e2c68ca8"
import script from "./Assinaturas.vue?vue&type=script&lang=js"
export * from "./Assinaturas.vue?vue&type=script&lang=js"
import style0 from "./Assinaturas.vue?vue&type=style&index=0&id=e2c68ca8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports